import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { UiRouteLinks } from '@lsq-frontend/angular-shared/app-constants';
import { FeatureFlagService } from '../../../services/feature-flag/feature-flag.service';

@Injectable()
export class FeatureFlagGuard implements CanActivate {
    constructor(private _featureFlagService: FeatureFlagService, private _router: Router) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        if (
            !route.data.featureFlag &&
            (!route.data.featureFlags || !route.data.featureFlags.length)
        ) {
            throw new Error(
                `Route ${state.url} is guarded with a FeatureFlagGuard, so expected to ` +
                    `find feature flags in 'data.featureFlags'; instead, got ${
                        route.data.featureFlag ? route.data.featureFlag : route.data.featureFlags
                    }`
            );
        }

        if (route.data.featureFlags && route.data.featureFlags.length) {
            return zip(
                ...(route.data.featureFlags as string[]).map((featureFlag) =>
                    this._featureFlagService.isOn(featureFlag)
                )
            ).pipe(
                map(
                    (areOn) =>
                        areOn.every((isOn) => isOn) ||
                        this._router.parseUrl(`/${UiRouteLinks.NotFound}`)
                )
            );
        }

        return this._featureFlagService
            .isOn(route.data.featureFlag)
            .pipe(map((isOn) => isOn || this._router.parseUrl(`/${UiRouteLinks.NotFound}`)));
    }
}
